import { useParams } from "react-router-dom";

import { parsePositiveIntParam } from "@src/shared/utils/params";

export function useEncounterIdFromParams(): number | undefined {
  const params = useParams();
  return parsePositiveIntParam(params.encounterId);
}
